function cov_1ougluautj() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeLocation.tsx";
  var hash = "66a10bb51f33819938fbda78bf74294c867126e8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeLocation.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "66a10bb51f33819938fbda78bf74294c867126e8"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ougluautj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1ougluautj();
var Icon = (cov_1ougluautj().s[0]++, {
  name: 'home-location',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 10.3016L12 5.05164L4.5 10.3016V19.5H19.5V10.3016ZM22 9.52066V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V9.52066C2 9.19434 2.15921 8.88855 2.42654 8.70143L11.4265 2.40143C11.7709 2.1604 12.2291 2.1604 12.5735 2.40143L21.5735 8.70143C21.8408 8.88855 22 9.19434 22 9.52066Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.2662 13.9968L13.1316 13.1315C13.6095 12.6536 13.6095 11.8788 13.1316 11.4009C12.6537 10.923 11.8788 10.923 11.4009 11.4009C10.923 11.8788 10.923 12.6536 11.4009 13.1315L12.2662 13.9968ZM14.8993 9.6331C13.4451 8.17888 11.0874 8.17888 9.63314 9.6331C8.17892 11.0873 8.17892 13.4451 9.63314 14.8993L12.2662 17.5324L14.8993 14.8993C16.3535 13.4451 16.3535 11.0873 14.8993 9.6331Z\" fill=\"currentColor\"/>"
});
export default Icon;